import { createFileRoute } from "@tanstack/react-router";
import PageLayout from "@/components/layout/PageLayout";
import ContactUs from "@/components/ui/ContactUs";

export const Route = createFileRoute("/contact")({
	component: () => (
		<PageLayout>
			<ContactUs />
		</PageLayout>
	),
});
